import Base from './base'

export default {
  GetList: (ctx?: any): Promise<any> => {
    return Base('/general/v1', ctx).get(`public/payment-methods`)
  }
}
